function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".warning-loan_svg__st0{fill:#aa1e1e}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "warning-loan_svg__st0",
  d: "M1176.1 1022.2L652.2 114.7c-10.8-18.7-30.8-30.2-52.4-30.2s-41.6 11.5-52.4 30.2L23.5 1022.2c-10.8 18.7-10.8 41.8 0 60.5 10.8 18.7 30.8 30.2 52.4 30.2h1047.9c21.6 0 41.6-11.5 52.4-30.2 10.7-18.8 10.7-41.8-.1-60.5zm-995.4-30.3l419.1-726 419.1 726H180.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "warning-loan_svg__st0",
  d: "M642.7 836.1c-11.5-10.2-25.7-15.3-42.9-15.3-17.1 0-31.4 5.1-42.9 15.3-11.5 10.2-17.2 23.2-17.2 39s5.7 28.8 17.2 39c11.4 10.2 25.7 15.3 42.9 15.3 17.1 0 31.4-5.1 42.9-15.3 11.4-10.2 17.2-23.2 17.2-39-.1-15.9-5.8-28.9-17.2-39zM556.8 775.6h87.6l13.8-319.5H543z"
});

function SvgWarningLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.667%",
    height: "4.667%",
    viewBox: "0 0 1200 1200"
  }, props), _ref, _ref2, _ref3);
}

export default SvgWarningLoan;